module.exports = __webpack_public_path__ + "4b5b38b688dfa7f58536f90f78ab22f5.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/goldencity3.jpg
// module id = 773
// module chunks = 0